import { useState } from "react"

/* 
    > sincer, nu cred ca am 'economisit' linii de cod, dar mi se pare
    mult mai usor de intretinut (si inteles) codul, multumita acestei
    abstractizari
    > also s-ar putea sa fie putin mai eficient fiindca in momentul in care
    apesi pe unul din butoane, se actualizeaza doar componenta asta, in loc sa
    se intample cu tot formularul (datorita apelului catre useState)
*/
function RadioList({ name, values, defaultValue, changeHandler }) {
    const [ value, setValue ] = useState(defaultValue)

    const valueId = (valueName) => `${name}-${valueName}`

    const valuesList = values.map(radioValue => {
        const valueName = valueId(radioValue.key)
        return <>
            <div key={`${valueName}-radio`}>
                <input 
                    type="radio"
                    key={valueName}
                    name={name}
                    value={valueName} 
                    id={valueName}
                    checked={value == radioValue.value}
                    onChange={e => {
                        setValue(radioValue.value)
                        if(changeHandler)
                            changeHandler(radioValue.value)
                    }} 
                    required
                />
                <label key={`${valueName}-label`} htmlFor={valueName}>
                    {radioValue.name}
                </label>
            </div>
        </>
    })

    return <>
        <div id={`${name}-radio`}>
            {valuesList}
        </div>
    </>
}

export default RadioList